import { FamilyDetailAnscNotificationsCancellationsCrumbs } from 'cancellations/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import ResearchFamilyNotificationsDetailCivilStatusShared from 'shell/components/shared/ansc-notifications/research-family/detail';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchFamilyNotificationsDetailCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchFamilyNotificationsDetailCivilStatusShared
        items={FamilyDetailAnscNotificationsCancellationsCrumbs()}
        scope={IdAmbito.Cancellazioni}
      />
    </Fragment>
  );
};

ResearchFamilyNotificationsDetailCivilStatusPage.displayName =
  'Research Family Notifications CivilStatusPage component';

export default ResearchFamilyNotificationsDetailCivilStatusPage;
